import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiInbox } from 'modules/api';
import { PagingParams } from 'modules/types/PagingParams';

export const fetchInboxMessages = createAsyncThunk(
  'inbox/getMessages',
  async (params: PagingParams, { rejectWithValue }) => {
    try {
      const response = await ApiInbox.getInboxMessages(params);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchUnreadMessageCount = createAsyncThunk(
  'inbo/getUnreadMessageCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiInbox.getUnreadesageCount();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const markInboxMessageAsRead = createAsyncThunk(
  'inbox/markMessageAsRead',
  async (id: number, { rejectWithValue }) => {
    try {
      await ApiInbox.markMessageAsRead(id);
      return id;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
